import {useAction}                    from '../../../useBaseHooks';
import {getMusicRecordAlbumsEndpoint} from '../../../endpoints/label/music/record/musicRecordEndpoints';

export const useMusicRecordAlbum = (recordId) => useAction(getMusicRecordAlbumsEndpoint(recordId), 'POST');